import { z } from 'zod';

export const DiningMenuSchema = z.object({
  id: z.string(),
  title: z.string(),
  url: z.string().nullable(),
});

export const DiningRestaurantSchema = z.object({
  id: z.string(),
  providerId: z.string(),
  restaurantName: z.string(),
  configName: z.string(),
  restaurantId: z.number(),
  name: z.string(),
  subtitle: z.string().nullable(),
  description: z.string().nullable(),
  imageUrls: z.array(z.string()),
  menus: z.array(DiningMenuSchema),
});

export type DiningRestaurant = z.infer<typeof DiningRestaurantSchema>;

export const DiningAvailablePromotionSchema = z.object({
  id: z.string(),
  timeslotReservationId: z.string().nullable(),
});

export const DiningPromotionSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const DiningAvailabilityTimeslotSchema = z.object({
  date: z.string(),
  timeSlot: z.string(),
  startTime: z.string(),
  leaveTime: z.string().nullable(),
  hasStandardAvailability: z.boolean(),
  standardAvailabilityFeeAmount: z.string().nullable(),
  timeslotReservationId: z.string().nullable(),
  maxPartySize: z.number().nullable(),
  minPartySize: z.number().nullable(),
  availablePromotions: z.array(DiningAvailablePromotionSchema),
});

export const DiningDayAvailabilitySchema = z.object({
  timeslots: z.array(DiningAvailabilityTimeslotSchema),
  promotions: z.array(DiningPromotionSchema),
});

export type DiningAvailabilityTimeslot = z.infer<typeof DiningAvailabilityTimeslotSchema>;
export type DiningPromotion = z.infer<typeof DiningPromotionSchema>;
export type DiningDayAvailability = z.infer<typeof DiningDayAvailabilitySchema>;
